/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Category_PlanInputs */

const en_us2_community_category_plan = /** @type {(inputs: Community_Category_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const pt_br2_community_category_plan = /** @type {(inputs: Community_Category_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano`)
};

const es_419_community_category_plan = /** @type {(inputs: Community_Category_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const pt_pt2_community_category_plan = /** @type {(inputs: Community_Category_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano`)
};

const fr_fr2_community_category_plan = /** @type {(inputs: Community_Category_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

const de_de2_community_category_plan = /** @type {(inputs: Community_Category_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const it_it2_community_category_plan = /** @type {(inputs: Community_Category_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Community_Category_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_category_plan = /** @type {((inputs?: Community_Category_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Category_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_category_plan(inputs)
	if (locale === "es-419") return es_419_community_category_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_community_category_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_community_category_plan(inputs)
	if (locale === "de-DE") return de_de2_community_category_plan(inputs)
	if (locale === "it-IT") return it_it2_community_category_plan(inputs)
	return en_us2_community_category_plan(inputs)
});
export { community_category_plan as "community.category_plan" }